module.exports = __webpack_public_path__ + "static/media/khushi.694c9a39.jpeg";